/**
 * Formatting utilities for DXF Nester results.
 */

export function formatSeconds(sec) {
  if (sec == null || sec === 0) return '—'
  const total = Math.round(sec)
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  if (h > 0) return `${h}h ${m}m ${s}s`
  return `${m}m ${s}s`
}

export function formatInches(val, decimals = 1) {
  if (val == null) return '—'
  return `${Number(val).toFixed(decimals)}"`
}

export function formatWeight(lbs) {
  if (lbs == null) return '—'
  return `${Number(lbs).toFixed(2)} lbs`
}

export function formatCurrency(val) {
  if (val == null) return '—'
  return `$${Number(val).toFixed(2)}`
}

export function formatPct(val) {
  if (val == null) return '—'
  return `${Number(val).toFixed(1)}%`
}
